import styled from 'styled-components';
import { Button } from 'client/widgets/ui';
import { observer } from 'mobx-react';
import { useArray, useBoolean, useNumber, useSetState, useStateful } from 'react-hanger';
import { geetest, hooks, request, user, storage, utils } from 'lib';
import assign from 'lodash/assign';
import { UiToast } from 'components';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import MobileLoginSelect from './mobile-login-select';
import { useStore } from './store';
import { OneLogin, ToggleLogin } from './common';
import S from './styled';

const { Form, FormTip, FormItem, Input } = S;
const BtnSend = styled(Button)`
  margin-left: 12px;
  padding-left: 0;
  padding-right: 0;
  font-size: var(--fs-md) !important;
`;

const InputCode = styled(Input)`
  width: 100px;
`;

const cacheKey = 'QT_MOBILE';

const MobileLogin = observer((props) => {
  const { show } = props;
  const { setLoginType } = useStore();
  const seconds = useNumber(0);
  const tip = useStateful('');
  const { query } = useRouter();
  const accounts = useArray([]);

  const isLoading = useBoolean(false);
  const { state, setState, resetState } = useSetState({
    mobile: '',
    sms_code: '',
  });

  useEffect(() => {
    const mobile = storage.getItem(cacheKey) || '';
    setState({
      mobile,
    });
  }, []);

  useEffect(() => {
    if (state.mobile) {
      storage.setItem(cacheKey, state.mobile);
    }
  }, [state.mobile]);

  const onChange = (e) => {
    let { name, value } = e.currentTarget;

    if (name === 'mobile') {
      value = value.replace(/\D/g, '');
    }

    setState({
      [name]: value.replace(/[\u4e00-\u9fa5]|\s/g, ''),
    });
  };
  const checkMobile = () => {
    if (state.mobile.length !== 11) {
      tip.setValue('请填写有效的手机号');
      return false;
    }
    tip.setValue('');
    return true;
  };

  const checkData = () => {
    if (state.sms_code.length === 0) {
      tip.setValue('请填写验证码');
      return false;
    }

    tip.setValue('');
    return true;
  };

  hooks.useInterval(
    () => {
      seconds.decrease();
    },
    seconds.value > 0 ? 1000 : null,
  );

  const onSendCode = (e) => {
    if (state.mobile.length === 0) {
      return;
    }
    e.preventDefault();
    if (!checkMobile()) {
      return;
    }

    geetest(
      'quick_login',
      (geetestData, captchaObj) => {
        // let isChina = currentCountry.value.country === '中国';
        let data = {
          mobile: state.mobile,
          nation_code: '+86',
        };
        data = assign(data, geetestData);
        captchaObj.reset();

        request.amber
          .post({
            url: 'api/v2/verify_code/quick_login',
            contentType: 'JSON',
            data,
          })
          .then(() => {
            seconds.setValue(60);
            UiToast.success('验证码发送成功');
          })
          .catch((res) => {
            tip.setValue(res.msg || '验证码发送失败');
          });
      },
      () => {
        tip.setValue('校验异常');
      },
      () => {},
    );
  };

  const onLogin = (e) => {
    if (isDisableSubmit) {
      return;
    }
    e.preventDefault();
    if (!checkMobile()) {
      return;
    }

    if (checkData() && !isLoading.value) {
      isLoading.setTrue();
      user.loginMobile({
        ...state,
        onSuccess: (res) => {
          isLoading.setFalse();
          // const { userInfo } = getGlobalStore();
          // if (!userInfo.isAnchor) {
          //   user.clearUserInfo();
          //   tip.setValue('登录失败，请先申请开播获得主播权限');
          //   return false;
          // }
        },
        onFail: (res) => {
          if (res.code === 1107 && res.accounts) {
            accounts.setValue(
              res.accounts.map((item) => {
                // 1天以内显示具体时间xx:xx:xx；1年以内显示xx天前；1年以上统一 显示1年前
                if (Date.now() - item.last_login_time > 1000 * 60 * 60 * 24 * 365) {
                  item.last_login_text = '1年前';
                } else if (Date.now() - item.last_login_time > 1000 * 60 * 60 * 24) {
                  item.last_login_text = `${Math.floor(
                    (Date.now() - item.last_login_time) / (1000 * 60 * 60 * 24),
                  )}天前`;
                } else {
                  item.last_login_text = utils.formatTime(item.last_login_time, 'hh:mm:ss');
                }
                return item;
              }),
            );
          } else {
            tip.setValue(res.msg);
          }
          isLoading.setFalse();
        },
      });
    }
  };

  const isDisableSubmit = state.mobile.length === 0 || state.sms_code.length === 0;

  const handleSelectAccount = (data) => {
    user.loginMobileSelect({
      data,
      onSuccess: (res) => {},
      onFail: (msg) => {
        UiToast.text(msg);
      },
    });
  };
  const handleBack = () => {
    accounts.setValue([]);
  };

  if (accounts.value.length) {
    return (
      <MobileLoginSelect
        mobile={state.mobile}
        onBack={handleBack}
        accounts={accounts.value}
        onSelect={handleSelectAccount}
      ></MobileLoginSelect>
    );
  }

  return (
    <Form show={show}>
      <FormItem>
        <Input
          placeholder="请输入手机号"
          name="mobile"
          value={state.mobile}
          type="tel"
          maxLength={11}
          onChange={onChange}
        ></Input>
      </FormItem>
      <FormItem>
        <InputCode
          placeholder="请输入验证码"
          name="sms_code"
          maxLength={6}
          value={state.sms_code}
          onChange={onChange}
        ></InputCode>
        {seconds.value > 0 ? (
          <BtnSend type="primary" round size="lg" disable>
            {seconds.value}秒后重新获取
          </BtnSend>
        ) : (
          <BtnSend
            type="primary"
            round
            size="lg"
            disable={state.mobile.length === 0}
            onClick={onSendCode}
          >
            获取验证码
          </BtnSend>
        )}
      </FormItem>
      <FormTip>{tip.value}</FormTip>
      <FormItem>
        <ToggleLogin
          onClick={() => {
            setLoginType('password');
          }}
        >
          密码登录
        </ToggleLogin>
      </FormItem>
      <FormItem>
        {isLoading.value ? (
          <Button type="primary" size="lg" disable round block>
            加载中...
          </Button>
        ) : (
          <Button type="primary" size="lg" round block disable={isDisableSubmit} onClick={onLogin}>
            登&nbsp;录
          </Button>
        )}
      </FormItem>
      <FormItem>
        <OneLogin></OneLogin>
      </FormItem>
    </Form>
  );
});

export default MobileLogin;
